import { jsx as i } from "react/jsx-runtime";
import { twMerge as c } from "tailwind-merge";
import { TextAlignEnum as r } from "../text-align-enum.mjs";
import s from "../../../icons/align-center-icon.mjs";
import a from "../../../icons/align-justify-icon.mjs";
import m from "../../../icons/align-left-icon.mjs";
import u from "../../../icons/align-right-icon.mjs";
const g = (e) => {
  const n = (t) => {
    const o = c(
      "stroke-text-primary",
      "group-hover:stroke-background-secondary",
      e === t && "stroke-background-secondary"
    );
    switch (t) {
      case r.Left:
        return /* @__PURE__ */ i(m, { className: o });
      case r.Right:
        return /* @__PURE__ */ i(u, { className: o });
      case r.Center:
        return /* @__PURE__ */ i(s, { className: o });
      case r.Justify:
        return /* @__PURE__ */ i(a, { className: o });
    }
  };
  return Object.values(r).map((t) => ({
    id: t,
    caption: t,
    customCaption: n(t)
  }));
}, I = (e) => {
  if (!e) return r.Left;
  const n = g().find(({ id: t }) => e.isActive({ textAlign: t }));
  return n ? n.id : r.Left;
};
export {
  I as getCurrentTextAlignValue,
  g as getTextAlignValues
};
